module.exports = __webpack_public_path__ + "static/media/error-page-ticket-icon.e82f60e8.svg";